import * as React from 'react';

import { cn } from '../../lib/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  suffix?: React.ReactNode;
  wrapperClassName?: string;
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, suffix, wrapperClassName, ...props }, ref) => {
    const inputClasses = cn(
      'flex h-10 w-full rounded-md border border-border bg-input px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-foreground focus-visible:outline-none focus-visible:border focus-visible:border focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
      suffix && 'rounded-r-none border-r-0',
      className,
    );

    if (suffix) {
      return (
        <div className={cn('flex w-full items-stretch', wrapperClassName)}>
          <input type={type} className={inputClasses} ref={ref} {...props} />
          <span className="flex items-center rounded-r-md border border-l-0 border-border bg-background-light px-3 text-sm text-foreground">
            {suffix}
          </span>
        </div>
      );
    }

    return <input type={type} className={inputClasses} ref={ref} {...props} />;
  },
);
Input.displayName = 'Input';

export { Input };
